import { render, staticRenderFns } from "./salesTableFwbj.vue?vue&type=template&id=246efc96"
import script from "./salesTableFwbj.vue?vue&type=script&lang=js"
export * from "./salesTableFwbj.vue?vue&type=script&lang=js"
import style0 from "./salesTableFwbj.vue?vue&type=style&index=0&id=246efc96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports